import React, { useState, useEffect, useContext } from "react";
import { Container, Col, Image, Row } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiUrl } from "../commons/inFormTypes";
import "react-multi-carousel/lib/styles.css";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import SwipeableViews from "react-swipeable-views";
import Header from "../components/Header";
import { toast } from "react-toastify";
import MunicipalityDataContext from "../helpers/MunicipalityDataContext";
import axiosInstance from "../api/axiosInstance";
import BigLoader from "../components/BigLoader";
import { findByLabelText } from "@testing-library/react";

const styles = {
  tabs: {
    background: "#fff",
    // minWidth: "max-content",
    // display: "inline-flex",
  },
  slide: {
    padding: 15,
    minHeight: 100,
    color: "#fff",
  },
  slide1: {
    backgroundColor: "#FEA900",
  },
  slide2: {
    backgroundColor: "#B3DC4A",
  },
  slide3: {
    backgroundColor: "#6AC0FF",
  },
};

function Dashboard() {
  const [load, setLoad] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [itemsListCity, setItemsListCity] = useState([]);
  const axios = require("axios");
  const [searchParams, setSearchParams] = useSearchParams();
  const promptId1 = searchParams.get("code");
  const promptId2 = searchParams.get("state");
  const navigate = useNavigate();
  const municipalitiyData = useContext(MunicipalityDataContext); //this context is for determine witch municipality to use
  const TokenId = localStorage.getItem("tokenId");
  const Mobile = localStorage.getItem("user_mobile");
  const UserID = localStorage.getItem("UserId");
  const hostname = window.location.hostname;

  useEffect(() => {
    //در این قسمت اگه تب روی هر تایتلی بود و ما وارد صفحه دیگری شدیم  دوباره برگشتیم به
    //  صفحه اصلی  تب باید روی همان تب باقی بمونه به خاطر همین از این قطعه کد استفاده کردیم
    const Tap1 = JSON.parse(localStorage.getItem("Tab"));
    if (Tap1 && Tap1 != null) {
      const Tap1 = JSON.parse(localStorage.getItem("Tab"));
      setTabIndex(Tap1);
    }

    setLoad(true);
    // لیست پرامیس‌هایی که قراره اجرا بشن
    const requests = [];

    if (promptId1 !== null && promptId2 !== null) {
      const loginReq = axios
        .get(`https://api.myamol.ir?code=${promptId1}&state=${promptId2}`)
        .then((res) => {
          if (res.data.result === "true") {
            localStorage.setItem("user_codemeli", res.data.data.CodeMelli);
            localStorage.setItem("user_mobile", res.data.data.Mobile);
            localStorage.setItem("user_namefamily", res.data.data.Firstname);
            localStorage.setItem("UserId", res.data.data.Id);
            localStorage.setItem("user_profile", res.data.data.Profile);
            localStorage.setItem("tokenId", res.data.data.TokenId);
            localStorage.setItem(
              "IsUserConfirmed",
              res.data.data.IsUserConfirmed
            );

            axiosInstance.post("GoToMade100").then((res2) => {
              if (res2.data.result === "true") {
                navigate("eblaghelectronici");
              }
            });

            navigate("/");
          } else {
            toast.error(res.data.message, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          }
        });
      requests.push(loginReq);
    } else {
      const gotoReq = axiosInstance.post("GoToMade100").then((res) => {
        if (res.data.result === "true") {
          navigate("eblaghelectronici");
        }
      });
      requests.push(gotoReq);
    }

    //لیست آیتم های داشبورد
    const listReq = axiosInstance
      .post("GetTabContent")
      .then((res) => {
        if (res.data.result === "true") {
          setItemsListCity(res.data.data);
        } else {
          toast.error(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      })
      .finally(() => {});

    requests.push(listReq);

    //بشه false  وقتی همه درخواست‌ها تموم شد، لودینگ
    Promise.all(requests)
      .catch((err) => {
        console.error("خطا در یکی از درخواست‌ها", err);
      })
      .finally(() => {
        setLoad(false);
      });
  }, []);

  const handleChange = (event, value) => {
    setTabIndex(value);
    localStorage.setItem("Tab", value);
  };

  const handleChangeIndex = (index) => {
    setTabIndex(index);
  };

  // const virtualVisitHandler = () => {
  //   toast.error("این قسمت در آینده اضافه خواهد شد", {
  //     position: toast.POSITION.TOP_CENTER,
  //     autoClose: 3000,
  //   });
  // };

 // mizkhedmat-true-https://esd.myamol.ir
  // const getTockenMizKhedmatHandler = () => {
  //   if (UserID === null) {
  //     switch (municipalitiyData?.name) {
  //       case "آمل":
  //         window.open("https://esd.myamol.ir", "_blank");
  //         break;
  //       case "رویان":
  //         window.open("https://app.royan.ir", "_blank");
  //         break;
  //       case "محمودآباد":
  //         window.open("https://app.mahmoodabad.ir", "_blank");
  //         break;
  //       default:
  //         break;
  //     }
  //   } else {
  //     switch (municipalitiyData?.name) {
  //       case "آمل":
  //         sendTokenRequest(
  //           apiUrl + "GenerateUserToken",
  //           UserID,
  //           Mobile,
  //           TokenId,
  //           "https://esd.myamol.ir"
  //         );
  //         break;
  //       case "رویان":
  //         sendTokenRequest(
  //           apiUrl + "GenerateUserToken",
  //           UserID,
  //           Mobile,
  //           TokenId,
  //           "https://app.royan.ir"
  //         );
  //         break;
  //       case "محمودآباد":
  //         sendTokenRequest(
  //           apiUrl + "GenerateUserToken",
  //           UserID,
  //           Mobile,
  //           TokenId,
  //           "https://app.mahmoodabad.ir"
  //         );
  //         break;
  //       default:
  //         console.log("نام شهرستان مشخص نیست");
  //         break;
  //     }
  //   }
  // };

  // const getTockenZistmandHandler = () => {
  //   if (UserID === null) {
  //     switch (municipalitiyData?.name) {
  //       case "آمل":
  //         window.open("https://zistmand.myamol.ir", "_blank");
  //         break;
  //       case "رویان":
  //         break;
  //       case "محمودآباد":
  //         break;
  //       default:
  //         break;
  //     }
  //   } else {
  //     switch (municipalitiyData?.name) {
  //       case "آمل":
  //         sendTokenRequest(
  //           apiUrl + "GenerateUserToken",
  //           UserID,
  //           Mobile,
  //           TokenId,
  //           "https://zistmand.myamol.ir"
  //         );
  //         break;
  //       case "رویان":
  //         break;
  //       case "محمودآباد":
  //         break;
  //       default:
  //         break;
  //     }
  //   }
  // };

  // const getTockenKhadamatELCHandler = () => {
  //   if (UserID === null) {
  //     switch (municipalitiyData?.name) {
  //       case "آمل":
  //         window.open(
  //           "https://esup.amol.ir/Api_Security/v2/auth/login-by-sso-amol",
  //           "_blank"
  //         );
  //         break;
  //       case "رویان":
  //         break;
  //       case "محمودآباد":
  //         break;
  //       default:
  //         break;
  //     }
  //   } else {
  //     switch (municipalitiyData?.name) {
  //       case "آمل":
  //         sendTokenRequest(
  //           apiUrl + "GenerateUserToken",
  //           UserID,
  //           Mobile,
  //           TokenId,
  //           "https://esup.amol.ir/Api_Security/v2/auth/login-by-sso-amol"
  //         );
  //         break;
  //       case "رویان":
  //         break;
  //       case "محمودآباد":
  //         break;
  //       default:
  //         break;
  //     }
  //   }
  // };

  const sendTokenRequest = (url, UserID, Mobile, TokenId, redirectUrl,tokenUrl) => {
 
 if(UserID !== null) {
       axios
      .post(url, {
        UserId: UserID,
        mobile: Mobile,
        token: TokenId,
      })
      .then((res) => {
        if (res.data.result === "true") {
                 console.log("redirectUrl",`${redirectUrl}${tokenUrl}${res.data.data}`)
          window.open(`${redirectUrl}${tokenUrl}${res.data.data}`, "_blank");
      
        } else {
          toast.error(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      });
 } else {
     window.open(`${redirectUrl}`, "_blank");
 }

  };

    const handleClick = (url) => () => {
    if (!url) return;

    if (url.startsWith("http")) {
      // لینک خارجی → باز کردن در تب جدید
      window.open(url, "_blank");
    } else if (url.startsWith("app")) { 
      //برای بخش میز خدمت ،خدمات الکتر.نیک و زیستماند 
            sendTokenRequest(
            apiUrl + "GenerateUserToken",
            UserID,
            Mobile,
            TokenId,
            url.split('::')[1],
            url.split('::')[2],
          );
    } else {
      // لینک داخلی → مسیریابی با react-router
      navigate(url);
    }
  };

  // const handleClick = (url) => () => {
  //   if (!url) return;

  //   if (url.startsWith("http")) {
  //     // لینک خارجی → باز کردن در تب جدید
  //     window.open(url, "_blank");
  //   } else if (url === "esup" || url === "zistmand" || url === "esd") {

  //     // ساب‌دامین یا لینک خاص → باز کردن در تب جدید یا تغییر رفتار
  //     switch (url) {
  //       case "esd":
  //         getTockenMizKhedmatHandler();
  //         break;
  //       case "zistmand":
  //         getTockenZistmandHandler();
  //         break;
  //       case "esup":
  //         getTockenKhadamatELCHandler();
  //         break;
  //       default:
  //         break;
  //     }
  //   } else {
  //     // لینک داخلی → مسیریابی با react-router
  //     navigate(url);
  //   }
  // };

  return (
    <>
      <div>
        <Header />
        <main>
          <div className="pt-0 pt-lg-5">
            <Container className="dashboard-tab">
              <Row className="justify-content-center mb-3">
                <Col xs={11} lg={8} className="g-0">
                  <div className="rgc-logo d-flex justify-content-center">
                    <div className="rgc-logo-part  d-flex flex-column text-center justify-conent-center gap-3 mb-5 col-11 col-md-6 col-lg-5">
                      <span>سامانه {municipalitiyData?.name} من</span>
                      <span>
                        خدمات آنلاین شهرداری {municipalitiyData?.name}
                      </span>

                      <form className="rgc-search mr-5 mt-5">
                        <input
                          className="form-control me-2 rgc-search"
                          type="search"
                          placeholder="جستجو..."
                          aria-label="Search"
                        />
                        <i className="fa-light fa-magnifying-glass"></i>
                        <i className="fa fa-search"></i>
                      </form>
                    </div>
                  </div>

                  {/* <div className="tabs-container">
                    <div className="tabs-scroll-wrapper"> */}
                  <Tabs
                    value={tabIndex}
                    fullWidth
                    onChange={handleChange}
                    style={styles.tabs}
                    classes={{
                      flexContainer: styles.tabsFlexContainer,
                      indicator: styles.indicator, // اضافه کردن استایل برای خط قرمز زیر تب‌ها
                    }}
                  >
                    {itemsListCity.map((data, index) => {
                      return <Tab key={index} label={data.TabTitle} />;
                    })}
                  </Tabs>
                  {/* </div>
                  </div> */}
                  <SwipeableViews
                    index={tabIndex}
                    onChangeIndex={handleChangeIndex}
                  >
                    {itemsListCity.map((tab, index) => {
                      return (
                        <div
                          key={index}
                          style={Object.assign({}, styles.slide)}
                        >
                          <Row className="justify-content-start">
                            {tab.TabContentCls.map((data, subIndex) => {
                              return (
                                <Col
                                  key={subIndex}
                                  xs={4}
                                  lg={3}
                                  className="sub-side mb-3"
                                  onClick={handleClick(data.Url)}
                                >
                                  <div className="rgc-card">
                                    <div className="d-flex flex-column rgc-card-img">
                                      <div className="rgc-icons">
                                        <Image src={data.Icon} alt=".." fluid />
                                      </div>

                                      <div className="rgc-card-body">
                                        <h6>{data.Title}</h6>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              );
                            })}
                          </Row>
                        </div>
                      );
                    })}
                  </SwipeableViews>
                </Col>
              </Row>
            </Container>
          </div>
        </main>
        <BigLoader loading={load} />
      </div>
      {/* <Footer /> */}
    </>
  );
}

export default Dashboard;
